import { ReactElement } from 'react';

import { FeaturesEnum } from '../features.enum';
import { FeatureAccessEnum } from '../enums/feature-access.enum';
import { getFeatureAccess, useFeatureAccess } from '../hooks/useFeatureAccess';
import { useGetProfile } from 'features/profiles';
import { useFeatureAccessContext } from '../feature-accesses.provider';

export const FeatureGuard: React.FC<{
  features: { feature: FeaturesEnum; access?: FeatureAccessEnum }[];
  fallback?: ReactElement;
}> = ({ features, children, fallback = <></> }) => {
  const { data: loggedInUser, isLoading } = useGetProfile();
  const { getAccessPermission } = useFeatureAccessContext();

  if (isLoading || !loggedInUser) {
    return null;
  }

  const hasAccess = features.some(({ feature, access = FeatureAccessEnum.READ }) => {
    const featureAccess = getFeatureAccess(feature, getAccessPermission, loggedInUser);
    return featureAccess?.[access];
  });

  return hasAccess ? <>{children}</> : fallback;
};
